/**
 * A geometria compartilhada por quem desenha EIXO.
 *
 * `SeriesChart` e `ComboChart` tem eixo; `Spark`, `CategoryBars` e `HorizontalBars`
 * nao, e por isso nao importam nada daqui.
 */

export const PAD = { top: 12, right: 14, bottom: 28, left: 52 }

/**
 * Escolhe marcas "redondas" para o eixo.
 *
 * Sem isto o eixo Y traz os extremos crus dos dados (`73,4`, `118,6`), que sao
 * numeros que ninguem le. O passo sai da sequencia 1-2-5 vezes potencia de dez, que
 * e o que produz marca legivel em qualquer ordem de grandeza.
 *
 * A ultima marca COBRE o maximo, sempre - mesmo que passe dele. Quem escala pelo
 * topo do eixo (o `ComboChart`) precisa disso: com maximo 33 as marcas paravam em
 * 30, e os valores entre 31 e 33 caiam FORA do grafico, com coordenada negativa. A
 * curva de ativos sumia para cima da area de desenho.
 */
export function niceTicks(min: number, max: number, count = 4): number[] {
    if (!Number.isFinite(min) || !Number.isFinite(max) || min === max) {
        return [min]
    }

    const raw = (max - min) / count
    const magnitude = 10 ** Math.floor(Math.log10(raw))
    const step = [1, 2, 5, 10].map((m) => m * magnitude).find((s) => s >= raw) ?? magnitude * 10

    const first = Math.ceil(min / step) * step
    const ticks: number[] = []
    for (let value = first; value <= max + step / 1000; value += step) {
        ticks.push(Number(value.toFixed(10)))
    }

    const last = ticks.at(-1)
    if (last === undefined || last < max) {
        ticks.push(Number(((last ?? first) + step).toFixed(10)))
    }

    return ticks
}
